import { combineReducers } from 'redux';

import coreProductInvoice from 'app/shared/reducers/analytics/coreProductInvoice';
import propertiesReport from 'app/shared/reducers/analytics/propertiesReport';
import boostAdReport from 'app/shared/reducers/analytics/boostAdReport';
import graphs from 'app/shared/reducers/analytics/graphs';
import overviewFilter from 'app/shared/reducers/analytics/overviewFilter';
import marketPropertiesSelect from 'app/shared/reducers/analytics/marketPropertiesSelect';

const rootAnalyticsReducer = combineReducers({
    coreProductInvoice,
    propertiesReport,
    boostAdReport,
    graphs,
    overviewFilter,
    marketPropertiesSelect,
});

export default rootAnalyticsReducer;
